import { BadgeProps } from "./Badge";

export const getBadgeIconSize = (badgeSize: BadgeProps["size"]) => {
  switch (badgeSize) {
    case "2xs": {
      return 12;
    }
    case "xs": {
      return 14;
    }
    case "sm": {
      return 16;
    }
    case "md": {
      return 18;
    }
    case "lg": {
      return 20;
    }
    case "xl": {
      return 24;
    }
  }
};
